/**
 * 支付相关模块
 */
import { post } from '@tencent/pmd-network';
import { loader as littleLoader } from '@tencent/pmd-tools/lib/little-loader';

// #ifdef MP-WEIXIN
import * as MidasPayApi from '@tencent/midas-mp-sdk/dist/index';
// #endif

declare let Midas: any;

export function orderAwardList(commercialManager, reqData, showMsgToast): Promise<void> {
  return new Promise((resolve, reject) => {
    post({
      url: commercialManager.getRequest('/pvpesport.sgamenes.award.award/OpAward'),
      reqData,
      showMsgToast,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/**
 * 查询用户道聚城余额
 */
export function queryUserCoin(commercialManager) {
  return new Promise((resolve, reject) => {
    post({
      url: commercialManager.getRequest('/pvpesport.sgamenes.award.award/QueryUserCoin'),
      reqData: {},
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/**
 * 拉起米大师支付
 * @param reqData 后台返回的订单数据
 */
export function pay(reqData) {
  return new Promise((resolve, reject) => {
    // #ifdef H5
    littleLoader('https://midas.gtimg.cn/h5pay/js/api/midas.js', () => {
      if (Midas) {
        const param = {
          params: reqData.url_params || '',
          pf: reqData.pf || '',
          sessionid: reqData.session_id || '',
          sessiontype: reqData.session_type || '',
          openkey: reqData.open_key || '',
          openid: reqData.openid || '',
          sandbox: reqData.midas_sandbox || 0,
          onSuccess() {
            resolve({});
          },
          onClose() {
            reject();
          },
        };
        Midas.buyGoods(param);
      }
    });
    // #endif
    // #ifdef MP-WEIXIN
    const goodsInstance = MidasPayApi.goods.init({
      env: reqData.midas_sandbox || 0,
    });
    goodsInstance.launchPay(
      {
        change_wx_openid: '', extend: '', login_wx_appid: '',
        offer_id: reqData.offer_id || '',
        openid: reqData.openid || '',
        pf: reqData.pf || '',
        session_id: reqData.session_id || '',
        session_type: reqData.session_type || '',
        zoneid: reqData.zone_id || '',
        goodstokenurl: reqData.url_params || '',
      },
      ({ resultCode, resultMsg, channel }) => {
        console.log(resultCode, resultMsg, channel);
        if (resultCode == 0) {
          resolve({});
        } else {
          reject();
        }
      },
    );
    // #endif
  });
}
